import cn from 'classnames';
import _ from 'lodash';
import moment from 'moment';
import printJS from 'print-js';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import MarketWbApi from '../../../API/market/wb-api';
import SuppliesApi from '../../../API/shipment/supplies-api';
import close from '../../../assets/media/icons/close.svg';
import { Column, NavTabs, Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Button, SendButton } from '../../../components/Basic/Buttons';
import { LinkBlue, Switch } from '../../../components/Basic/Elements';
import { Content, PageTitle } from '../../../components/Basic/Global';
import { DateInput, Input, InputLabel, Select } from '../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableHeader, TablePagination } from '../../../components/Basic/Table';
import { H1, H3, Text, TextGrey } from '../../../components/Basic/WrapsStyle';
import {
  MAP_SKLAD,
  MARKETS_ALL,
  SHIPMENT_STATUS,
  SHIPMENT_STATUS_TEXT,
  STATUS_COLORS,
  TYPE_BUTTONS,
  WB_MARKETS_MAP,
  WB_MARKETS_MAP_REVERSE
} from '../../../constans';
import { getDate, numberWithSpaces } from '../../../utils';
import WarehouseSelect from '../Supplies/WarehouseSelect';
import SearchCardsBlock from './SearchCardsBlock';
import styles from './styles.module.scss';
import SupplyItemLine from './SupplyItemLine';
import ChznWindowPopUp from './SupplyItemLine/ChznWindow';


export const MARKETS_LIST = ['Не выбрана', 'Ozon', 'Wb', 'Yandex', 'Megamarket', 'Avito'];

const MODES = ['Режим коробов', 'Режим статистики', 'Режим по дням'];

export const WIDTH_POSTING = [
  '150px', // 0
  '400px', // 1
  '200px', // 2
  '200px', // 3
  '180px', // 4
  '127px', // 5
  '100px', // 6
  '200px', // 7
  '100px', // 8
  '40px', // 9
  '100px', // 10
  '250px', // 11
  '170px', // 12
  '140px', // 13
  '120px', // 14
  '90px', // 15
  '70px', // 16
  '30px', // 17
  '330px', // 18
];

const SORT_TYPE = [
  { name: 'Не выбран', value: undefined },
  { name: 'По прибыли', value: 'earn' },
  { name: 'По убытку', value: 'lost' },
  { name: 'По кол-ву продаж', value: 'sale_count' },
  { name: 'По кол-ву заказов', value: 'orders_count' },
  { name: 'По сумме хранения', value: 'storage_sum' },
  { name: 'По кол-ву заказов в день', value: 'orders_in_days' },
  { name: 'Пора заказывать ', value: 'days_left' },
  { name: 'По дате заказов', value: 'orders_days' },
];

const NAVIGATE = {
  'Режим коробов': ['Товары', 'Не обработано', 'Частично обработано', 'Обработано', 'В нескольких коробах', 'Без короба'],
  'Режим статистики': ['Товары', 'Продано', 'Всё заказано', 'Частично продано', 'Доставляется', 'Не заказывалось', 'Отмены', 'Возвраты пвз', 'Не принято', 'На раскладке', 'Возврат заблокированного', 'Странное'],
  'Режим по дням': [],
  // 'Режим со склада': [],
};

const FILTER = {
  'Режим коробов': {
    0: 'products_all',
    1: 'products_not_processed',
    2: 'products_processed_partly',
    3: 'products_processed',
    4: 'products_some_boxes',
    5: 'products_no_box',
  },
  'Режим статистики': {
    0: 'products_grouped',
    1: 'products_grouped_all_sold',
    2: 'products_grouped_all_ordered',
    3: 'products_grouped_partly',
    4: 'products_grouped_delivery',
    5: 'products_grouped_not_ordered',
    6: 'products_grouped_cancels',
    7: 'products_grouped_return_pvz',
    8: 'products_not_accepted',
    9: 'products_unloading',
    10: 'products_return_blocked',
    11: 'products_strange',
  },
  'Режим по дням': {
    0: 'days_grouped',
  }
};

let abortController = new AbortController();

function SupplyPage({ }) {
  let location = useLocation();
  const { id } = useParams();

  const allProducts = !id
  const manySupplies = id?.split('&').length > 1 || allProducts
  const user = useSelector((store) => store.user);
  const isOwner = user.role === 'owner' || user.role === 'admin';
  const isUser = user.role === 'user';
  // const modes = manySupplies ? MODES.slice(1) : MODES
  const packageMethods = useSelector((store) => store.packaging);

  const [mode, setMode] = useState((isOwner || isUser) ? MODES[1] : MODES[0]);

  const [tab, setTab] = useState(0);
  const [count, setCount] = useState([]);
  const [page, setPage] = useState(1);
  const [show, setShow] = useState(25);
  const [countStock, setCountStock] = useState([0]);

  const [supply, setSupply] = useState({ market: '', shop: '', time_scheduled: '' });
  const [warehouseWbInfo, setWarehouseWbInfo] = useState({});
  const [warehouseWbNameSelect, setWarehouseWbNameSelect] = useState();
  const [supplies, setSupplies] = useState([{ market: '', shop: '', time_scheduled: '' }]);
  const [market, setMarket] = useState('');
  const [warehouses, setWarehouses] = useState([]);

  const [supplyItems, setSupplyItems] = useState({ ids: [], byIds: {} });
  const [potentialProfit, setPotentialProfit] = useState('');
  const [volume, setVolume] = useState({ common: 0, packed: 0 });


  const [search, setSearch] = useState(location.state?.posting_number || '');
  const [provider, changeProvider] = useState({ name: 'Не выбран', id: null });
  // const [activeBox, setActiveBox] = useState(null);
  const [boxFilter, setBoxFilter] = useState('Не выбран');
  const [notDebited, setNotDebited] = useState(false);
  const [orderDt, setOrderDt] = useState(null);
  const [sortType, setSortType] = useState(_.last(SORT_TYPE));

  const [pricesMode, setPricesMode] = useState(false);
  const [searchSkladMode, setSearchSkladMode] = useState(false);

  const [openChzn, setOpenChzn] = useState({ product: null, posting: null, open: false });
  const [chzn, setChzn] = useState('Не выбран');


  const useFocus = () => {
    const htmlElRef = useRef(null);
    const setFocus = () => {
      htmlElRef.current && htmlElRef.current.focus();
      htmlElRef.current && htmlElRef.current.select();
    };

    return [htmlElRef, setFocus];
  };
  const [inputRef, setInputFocus] = useFocus();



  const [providers, setProviders] = useState([]);
  const [providersIdInShipment, setProvidersIdInShipment] = useState([]);
  const allProviders = useSelector((store) => store.providers);

  const [profitStatistic, setProfitStatistic] = useState({});
  const [storageStatistic, setStorageStatistic] = useState({});


  const onChangePage = (v) => { setPage(v) }
  const onChangeTab = (n) => { setTab(n) }


  const params = useMemo(() => {
    return {
      supplyIds: id?.split('&').map(id => +id),
      limit: parseInt(show),
      page,
      boxFilter: boxFilter === 'Не выбран' ? undefined : boxFilter === 'Не указан' ? null : +boxFilter,
      search: search.trim(),
      providerId: provider.id,
      tab: FILTER[mode][tab],
      notDebited,
      filters: {
      },
    };
  }, [
    id,
    show,
    mode,
    page,
    search,
    tab,
    provider.id,
    boxFilter,
    notDebited,
  ]);



  const params_stat = useMemo(() => {
    return {
      supplyIds: id?.split('&').map(id => +id),
      limit: parseInt(show),
      page,
      search: search.trim(),
      providerId: provider.id,
      tab: FILTER[mode][tab],
      sortType: sortType.value,
      filters: {
        orderDt
      },
    };
  }, [
    id,
    show,
    mode,
    sortType,
    orderDt,
    page,
    search,
    tab,
    provider.id,
  ]);


  const params_days = useMemo(() => {
    return {
      supplyIds: id?.split('&').map(id => +id),
      limit: parseInt(show),
      page,
      search: search.trim(),
      providerId: provider.id,
      tab: FILTER[mode][tab],
      sortType: sortType.value,
      filters: {
        orderDt
      },
    };
  }, [
    id,
    show,
    orderDt,
    mode,
    sortType,
    page,
    search,
    tab,
    provider.id,
  ]);

  const getByDateStat = (date) => {
    setOrderDt(date)
    setMode(MODES[1])
  }


  const loadData = () => {
    abortController.abort(); // Cancel the previous request
    abortController = new AbortController();

    SuppliesApi.getSupplyItems({ data: params, signal: abortController.signal })
      .then((res) => {
        const { supplyItems, supplies, count, tabs } = res;
        setSupply(supplies[0]);
        setSupplies(res.supplies);
        setCountStock(Object.values(tabs));
        const byIds = {};

        const ids = supplyItems.map((item) => item._id);
        supplyItems.forEach((item) => (byIds[item._id] = item));
        setSupplyItems({ byIds, ids });
        // if (!activeBox && !manySupplies)
        // setActiveBox(_.last(supplies[0]?.boxes)?.id)
        // setWarehouseProductsMap(res.warehouseProductsMap);
        // setProvidersIdInShipment(res.providersIdsInShipments);
        setCount(count);

        const p = allProviders.filter((item) => res.providersIdsInShipments?.includes(item.id));
        setProviders([{ name: 'Не выбран', id: null }, ...p] || allProviders);
      })
  };



  const loadStatistic = () => {
    abortController.abort(); // Cancel the previous request
    abortController = new AbortController();
    SuppliesApi.getSupplyItemsStat({ data: params_stat, signal: abortController.signal })
      .then((res) => {
        const { supplyItems, supplies, volume, count, tabs, potentialProfit } = res;
        setSupply(res.supplies[0]);
        setSupplies(res.supplies);
        setCountStock(Object.values(tabs));
        const byIds = {};

        const ids = supplyItems.map((item) => item._id);
        supplyItems.forEach((item) => (byIds[item._id] = item));
        setSupplyItems({ byIds, ids });
        setPotentialProfit(potentialProfit);
        setVolume(volume);

        // setProvidersIdInShipment(res.providersIdsInShipments);
        setProfitStatistic(res.profitStatistic)
        setStorageStatistic(res.storageStatistic)
        setCount(count);

        const p = allProviders.filter((item) => res.providersIdsInShipments?.includes(item.id));
        setProviders([{ name: 'Не выбран', id: null }, ...p] || allProviders);
      })
  };


  const loadDays = () => {
    abortController.abort(); // Cancel the previous request
    abortController = new AbortController();
    SuppliesApi.getSupplyItemsDays({ data: params_days, signal: abortController.signal })
      .then((res) => {
        const { supplyItems, supplies, count, tabs } = res;
        setSupply(res.supplies[0]);
        setSupplies(res.supplies);
        // setCountStock(Object.values(tabs));

        const byIds = {};
        const ids = supplyItems.map((item) => item._id);
        supplyItems.forEach((item) => (byIds[item._id] = item));
        setSupplyItems({ byIds, ids });
        // setProvidersIdInShipment(res.providersIdsInShipments);
        setProfitStatistic(res.profitStatistic)
        setStorageStatistic(res.storageStatistic)
        setCount(count);
      })
  };


  useEffect(() => {
    if (mode === 'Режим коробов') {
      loadData();
    }
    if (mode === 'Режим статистики') {
      loadStatistic();
    }
    if (mode === 'Режим по дням') {
      loadDays();
    }
  }, [params, params_stat, params_days, mode]);

  const loadPage = async () => {
    if (mode === 'Режим коробов') loadData();
    if (mode === 'Режим статистики') loadStatistic();
    if (mode === 'Режим по дням') loadDays();
  }

  useEffect(() => {
    if (isOwner || isUser)
      SuppliesApi.getWarehouses({ data: {} }).then(r => { setWarehouses(r.warehouses) })
  }, []);


  const changeProductsInSupply = async ({ action, supplyId, shop, offerId, quantity, boxId, value, boxNumber }) => {
    await SuppliesApi.changeProductsInSupply({ data: { supplyId, action, offerId, quantity, shop, boxId, value: value === 'Нет' ? null : value, boxNumber } })
      .catch(console.log)
    await loadPage()
  }

  const printSticker = async ({ offerId, shop, supplyId, productQuantity, barcodeQuantity, boxId, action }) => {

    let file = await MarketWbApi.fboSticker({ data: { offerId, shop, quantity: barcodeQuantity } })
    await changeProductsInSupply({ action: action || 'add_quantity_in_box', supplyId: supplyId || supply.id, shop, offerId, quantity: productQuantity, boxId })

    printJS({
      printable: file,
      type: 'pdf',
      base64: true,
      showModal: false,
      onPrintDialogClose: () => {
        window.focus();
      },
    });

    setInputFocus()

  }

  const colorByPercent = (perc) => {
    if (perc >= 90) return '#168600ff'
    if (perc >= 80) return '#56b601ff'
    if (perc >= 70) return '#99aa00ff'
    if (perc >= 60) return '#aa6c00ff'
    return '#aa0000ff'
  }


  const onChangeCard = async (offer_id, shop, key, value) => {

    if (key === 'price' || key === 'discount') {
      await MarketWbApi.changePrice({ data: { shop, offer_id, field: key, value: parseInt(value) } })
    }
    if (key === 'percent' || key === 'min_rub') {
      await MarketWbApi.changeMarginality({ data: { shop, offer_id, field: key, value: parseInt(value) } })
    } else {
      await MarketWbApi.changeCard({ data: { shop, offer_id, field: key, value } })
    }

    await loadPage()
  }

  useEffect(() => {

    if ((isOwner || isUser) && (warehouseWbNameSelect || supply.wb_info?.sklad) && supply.wb_info?.date)
      SuppliesApi.getWarehouses({ data: { warehouseName: warehouseWbNameSelect || supply.wb_info.sklad, date: supply.wb_info.date } }).then(r => {
        setWarehouseWbInfo(r.warehouse)
      })
  }, [warehouseWbNameSelect, supply.wb_info?.date])

  const isAdmin = isOwner || user.role === 'user';

  const tab_name = manySupplies ? 'Совместная поставка' : `Поставка: ${supply.market || ''} ${supply.time_scheduled ? getDate(supply.time_scheduled) : ''} ${supply.id}`;

  return (
    <>
      <PageTitle title={tab_name || ''} />
      <Content>
        {!allProducts && <>
          <H1 style={{ marginBottom: '-3px' }}>
            {manySupplies ? 'Совместная поставка:' + supplies.map(s => ` ${s.id || ''} (${s.shop})`).join(' ,') : `Поставка: ${supply.market || ''}  ${supply.time_scheduled ? getDate(supply.time_scheduled) : ''} ${MAP_SKLAD[supply.sklad]}  (${supply.id})`}
          </H1>
          <LinkBlue to={'/fbo/supplies'} style={{ marginBottom: '10px' }}>
            Вернуться к поставкам
          </LinkBlue>
        </>}

        <Row style={{ alignItems: 'flex-start' }}>
          {!manySupplies && <WhiteBlock style={{}} minimize={true}>
            <H3 style={{ marginBottom: '15px' }}>

              <div style={{ marginBottom: '5px', color: '#000000b2' }}>
                Статус: <span style={{ fontWeight: 'bold', color: STATUS_COLORS[supply.wb_info?.status || supply.state] }}>{supply.wb_info?.status || SHIPMENT_STATUS_TEXT[supply.state]}</span>
              </div>

              {supply.wb_info?.supplied_date && (<div style={{ color: '#000000b2' }}>Дата пропика: <span style={{ fontWeight: 'bold', color: '#000000' }}>{moment(supply.wb_info?.supplied_date).format('DD.MM.YYYY HH:mm')}</span></div>)}
            </H3>
            <Row style={{ marginTop: '10px' }}>
              <Column>
                <>
                  <Row style={{ alignItems: 'flex-end' }}>
                    <Row style={{ marginRight: '10px' }}>
                      <Select
                        list={MARKETS_ALL[supply.market]}
                        disabled={true}
                        select={WB_MARKETS_MAP_REVERSE[supply.shop]}
                        label="Магазин"
                        onSelect={async (v) => {
                          const newSupply = await SuppliesApi.changeSupply({ data: { supplyId: supply.id, field: 'shop', value: WB_MARKETS_MAP[v] } }).then(r => r.supply)
                          setSupply(newSupply)
                        }}
                        width={'150px'}
                      />
                    </Row>
                    {/* <Row>
                      <Select
                        // big={true}
                        label="Активный короб"
                        select={activeBox}
                        width="150px"
                        style={{ marginLeft: '15px' }}
                        list={supply?.boxes?.map(b => b.id) || []}
                        onSelect={(v) => setActiveBox(+v)}
                      />
                    </Row> */}
                    {/* <Button
                      style={{ marginLeft: '30px' }}
                      type={TYPE_BUTTONS.BLUE}
                      // disabled={supply.state !== SHIPMENT_STATUS.READY}
                      onClick={async () => {
                        await SuppliesApi.debitWarehouse({ data: { supplyId: supply.id } })
                        await loadPage()
                      }}
                    >
                      Списать со склада
                    </Button> */}
                  </Row>
                  <Row style={{ marginTop: '0px' }}>
                    <Column>
                      <DateInput
                        label="Дата отгрузки"
                        value={supply.time_scheduled}
                        onChange={async (v) => {
                          const newSupply = await SuppliesApi.changeSupply({ data: { supplyId: supply.id, field: 'time_scheduled', value: new Date(v) } }).then(r => r.supply)
                          setSupply(newSupply)
                        }}
                      />
                      <div style={{ marginTop: '14px' }}>
                        <Input
                          label='Склад поставки'
                          width={"200px"}
                          disabled={true}
                          value={supply?.wb_info?.sklad}
                        />
                      </div>
                    </Column>
                    <Column
                      style={{ marginLeft: '30px', marginTop: '35px' }}
                    >
                      <Button
                        style={{ width: '100%' }}
                        type={TYPE_BUTTONS.GREEN}
                        disabled={supply.state !== SHIPMENT_STATUS.READY}
                        onClick={async () => {
                          const newSupply = await SuppliesApi.changeSupply({ data: { supplyId: supply.id, field: 'state', value: SHIPMENT_STATUS.STARTED } }).then(r => r.supply)
                          setSupply(newSupply)
                        }}
                      >
                        Начать отгрузку
                      </Button>
                      <Button
                        type={TYPE_BUTTONS.BLUE}
                        disabled={supply.state !== SHIPMENT_STATUS.STARTED}
                        onClick={async () => {
                          const newSupply = await SuppliesApi.changeSupply({ data: { supplyId: supply.id, field: 'state', value: SHIPMENT_STATUS.END } }).then(r => r.supply)
                          setSupply(newSupply)
                        }}
                        style={{ width: '100%', marginTop: '14px' }}
                      >
                        Закончить отгузку
                      </Button>
                    </Column>
                  </Row>
                </>


              </Column>
              <Column style={{ marginTop: '14px' }}></Column>
            </Row>
          </WhiteBlock >}
          {(mode === 'Режим коробов' && !manySupplies) && (
            <WhiteBlock style={{ marginLeft: '20px', maxHeight: 'fit-content' }} title="Короба" left={true} minimize={true} openBlock={true}>
              <div style={{ width: '100%', maxHeight: '400px', overflowY: 'auto', marginBottom: '20px' }}>
                <table style={{ boxShadow: '2px 2px 2px rgba(109, 109, 109, 0.42)' }} className={styles.table_stat}>
                  <thead>
                    <tr>
                      <th>
                        Номер короба
                      </th>
                      <th>Штрихкод</th>
                      <th>Номер в системе WB</th>
                      <th>Удалить</th>
                    </tr>
                  </thead>
                  <tbody>
                    {supply?.boxes
                      // .sort((a, b) => b.count_not_printed - a.count_not_printed)
                      ?.map((b) => {
                        return (
                          <tr key={b._id}>
                            <td style={{ fontSize: '18px', textAlign: 'center' }}>{b.id}</td>
                            <td
                              style={{ cursor: 'pointer', textAlign: 'center' }}
                              className={cn(styles.icon, styles.excel)}
                              onClick={async () => {
                                let file = await SuppliesApi.boxSticker({ data: { supplyId: supply.id, boxNumber: b.id } })
                                printJS({
                                  printable: file,
                                  type: 'pdf',
                                  base64: true,
                                  showModal: false,
                                  onPrintDialogClose: () => {
                                    window.focus();
                                  },
                                });
                              }}
                            >Печать</td>
                            <td style={{ fontSize: '18px', textAlign: 'center' }}>
                              <Input
                                center
                                value={b.wb_number}
                                onBlur={async (v) => {
                                  const newSupply = await SuppliesApi.changeSupplyBox({ data: { supplyId: supply.id, action: 'change_wb_number', boxNumber: b.id, value: v } }).then(r => r.supply)
                                  setSupply(newSupply)

                                }}
                                onClickEnter={async (v) => {
                                  const newSupply = await SuppliesApi.changeSupplyBox({ data: { supplyId: supply.id, action: 'change_wb_number', boxNumber: b.id, value: v } }).then(r => r.supply)
                                  setSupply(newSupply)
                                }}
                              />
                            </td>
                            <td
                              className={cn(styles.icon, styles.delete)}
                              style={{ cursor: 'pointer' }}
                              onClick={async () => {
                                const newSupply = await SuppliesApi.changeSupplyBox({ data: { supplyId: supply.id, action: 'delete', boxNumber: b.id } }).then(r => r.supply)
                                setSupply(newSupply)
                              }}
                            >
                              <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <img src={close} style={{ width: '15px' }} />
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
              <Row>
                <Button
                  type={TYPE_BUTTONS.BLUE}
                  onClick={async () => {
                    const newSupply = await SuppliesApi.changeSupplyBox({ data: { supplyId: supply.id, action: 'add' } }).then(r => r.supply)
                    setSupply(newSupply)
                  }}
                >
                  Добавить короб
                </Button>
                <Button
                  type={TYPE_BUTTONS.BLUE}
                  style={{ marginLeft: '20px', width: '100%' }}
                  onClick={async () => {
                    let file = await SuppliesApi.boxWbStickers({ data: { supplyId: supply.id } })
                    printJS({
                      printable: file,
                      type: 'pdf',
                      base64: true,
                      showModal: false,
                      onPrintDialogClose: () => {
                        window.focus();
                      },
                    });
                  }}
                >
                  Стикеры на короба
                </Button>
                <Button
                  style={{ marginLeft: '20px' }}
                  type={TYPE_BUTTONS.GREEN}
                  onClick={async () => {
                    await SuppliesApi.excelBoxes({ data: { supplyId: supply.id, type: 'first' } })
                  }}
                >
                  Первый Excel
                </Button>
                <Button
                  style={{ marginLeft: '20px' }}
                  type={TYPE_BUTTONS.GREEN}
                  onClick={async () => {
                    await SuppliesApi.excelBoxes({ data: { supplyId: supply.id, type: 'first', isOrderedQuantity: true } })
                  }}
                >
                  Первый Excel (все позиции)
                </Button>
                <Button
                  style={{ marginLeft: '20px' }}
                  type={TYPE_BUTTONS.GREEN}
                  onClick={async () => {
                    await SuppliesApi.excelBoxes({ data: { supplyId: supply.id, type: 'second' } })
                  }}
                >
                  Второй Excel
                </Button>
              </Row>
            </WhiteBlock>
          )}
          {(isOwner || isUser) && (mode !== MODES[0]) && !manySupplies && (
            <WhiteBlock style={{ marginLeft: '20px', width: 'max-content' }} title="Управление поставкой" left={true} minimize={true} openBlock={true}>
              <Row style={{ alignItems: 'start' }}>
                <div style={{ minWidth: '250px', marginRight: '0px' }}>
                  <div style={{ marginTop: '20px', textAlign: 'center', fontWeight: 'bold', color: '#0000009e' }}>Информация для наклеек</div>
                  <Input
                    value={supply.wb_info?.number}
                    onBlur={async (v) => {
                      const newSupply = await SuppliesApi.changeSupply({ data: { supplyId: supply.id, field: 'wb_info.number', value: v } }).then(r => r.supply)
                      setSupply(newSupply)
                    }}
                    label="Номер поставки"
                  />
                  <Input
                    value={supply.wb_info?.sklad_id}
                    onBlur={async (v) => {
                      const newSupply = await SuppliesApi.changeSupply({ data: { supplyId: supply.id, field: 'wb_info.sklad_id', value: v } }).then(r => r.supply)
                      setSupply(newSupply)
                    }}
                    label="ID склада"
                  />
                  <Input
                    label='Склад поставки'
                    disabled={true}
                    value={supply?.wb_info?.sklad}
                  />
                  <Input
                    value={supply.wb_info?.type}
                    onBlur={async (v) => {
                      const newSupply = await SuppliesApi.changeSupply({ data: { supplyId: supply.id, field: 'wb_info.type', value: v } }).then(r => r.supply)
                      setSupply(newSupply)
                    }}
                    label="Тип поставки"
                  />
                  <Input
                    value={supply.wb_info?.ip_name}
                    onBlur={async (v) => {
                      const newSupply = await SuppliesApi.changeSupply({ data: { supplyId: supply.id, field: 'wb_info.ip_name', value: v } }).then(r => r.supply)
                      setSupply(newSupply)
                    }}
                    label="Наименование юридического лица"
                  />
                  <DateInput
                    value={supply.wb_info?.date}
                    onChange={async (v) => {
                      const newSupply = await SuppliesApi.changeSupply({ data: { supplyId: supply.id, field: 'wb_info.date', value: new Date(v) } }).then(r => r.supply)
                      setSupply(newSupply)
                    }}
                    label="Дата поставки"
                  />
                  <Button
                    type={TYPE_BUTTONS.BLUE}
                    style={{ marginTop: '20px', width: '100%' }}
                    onClick={async () => {
                      let file = await SuppliesApi.boxWbStickers({ data: { supplyId: supply.id } })
                      printJS({
                        printable: file,
                        type: 'pdf',
                        base64: true,
                        showModal: false,
                        onPrintDialogClose: () => {
                          window.focus();
                        },
                      });
                    }}
                  >
                    Стикеры на короба
                  </Button>
                </div>
                <div style={{ margin: '0 30px', borderRight: '2px solid #00000046', display: 'flex', alignSelf: 'stretch' }}></div>
                <div>
                  <div style={{ marginTop: '20px', textAlign: 'center', fontWeight: 'bold', color: '#0000009e' }}>Тариф на дату: {getDate(supply.wb_info?.date || moment())}</div>
                  <div style={{ marginTop: '30px' }}>
                    <WarehouseSelect
                      // label='Склад поставки'
                      width={"100%"}
                      style={{ marginBottom: '30px' }}
                      warehouses={warehouses}
                      warehouse={warehouseWbNameSelect || supply.wb_info?.sklad}
                      onChange={async (v) => {
                        // const newSupply = await SuppliesApi.changeSupply({ data: { supplyId: supply.id, field: 'wb_info.sklad', value: v.name || '' } }).then(r => r.supply)
                        setWarehouseWbNameSelect(v.name)
                      }}
                    />
                    {Object.entries({
                      'ID склада': warehouseWbInfo?.ID,
                      'Название склада': warehouseWbInfo?.name,
                      // 'Адресс': selectedWarehouse.address,
                      // 'Дата': moment(d.date).format('YYYY-MM-DD'),
                      'Коэффициент приёмки': !warehouseWbInfo.tariff ? 'НЕ НАЙДЕНО' : (warehouseWbInfo.tariff.coefficient === -1 || !warehouseWbInfo.tariff.allowUnload) ? 'НЕДОСТУПНА' : warehouseWbInfo.tariff?.coefficient === 0 ? 'Бесплатно' : 'Платно',
                      ...(warehouseWbInfo.tariff && warehouseWbInfo.tariff.coefficient !== -1 && warehouseWbInfo.tariff.allowUnload && {
                        'Коэффициент хранения': `${warehouseWbInfo.tariff?.storageCoef}`,
                        'Хранение первого литра': `${warehouseWbInfo.tariff?.storageBaseLiter}`,
                        'Хранение последующего литра': `${warehouseWbInfo.tariff?.storageAdditionalLiter}`,
                        'Коэффициент логистики': `${warehouseWbInfo.tariff?.deliveryCoef}`,
                        'Логистика первого литра': `${warehouseWbInfo.tariff?.deliveryBaseLiter}`,
                        'Логистика последующего литра': `${warehouseWbInfo.tariff?.deliveryAdditionalLiter}`,
                      })
                    }).map(([key, value]) => {
                      return (
                        <div key={key} style={{ ...(['Коэффициент хранения', 'Коэффициент логистики'].includes(key) && { marginTop: '22px' }), }}>
                          <span style={{ color: '#0000009f' }}>{key}: </span>
                          {value}
                        </div>
                      )
                    })}

                  </div>
                  <hr style={{ marginTop: '15px', width: '100%' }}></hr>

                  <Row style={{ marginTop: '15px' }}>
                    <Button
                      style={{ marginRight: '20px' }}
                      type={TYPE_BUTTONS.BLUE}
                      disabled={!(warehouseWbInfo.tariff && warehouseWbInfo.tariff.coefficient !== -1 && warehouseWbInfo.tariff.allowUnload)}
                      onClick={async () => {
                        await SuppliesApi.saveTariff({ data: { supplyId: supply.id, warehouseWbInfo } })
                        await loadPage()
                      }}
                    >
                      Фиксировать
                    </Button>

                    <Button type={TYPE_BUTTONS.WHITE}
                      // disabled={!(supply.wb_info?.sklad_id && supply.wb_info?.tariff.coefficient !== -1)}
                      disabled={!(warehouseWbInfo?.ID && warehouseWbInfo?.tariff?.coefficient !== -1)}
                      onClick={() => {
                        SuppliesApi.checkSupplyList({ data: { supplyId: supply.id, shop: supply.shop, warehouseId: +warehouseWbInfo.ID }, options: { download: true } })
                      }}
                    >
                      {warehouseWbInfo?.tariff?.coefficient !== -1 ? 'Проверить доступность' : 'Не доступно'}
                    </Button>
                  </Row>

                </div>
                <div style={{ margin: '0 30px', borderRight: '2px solid #00000046', display: 'flex', alignSelf: 'stretch' }}></div>
                <div style={{ display: 'flex', flexDirection: 'column', height: 'stretch', justifyContent: 'space-between' }}>

                  <div>
                    <div style={{ marginTop: '15px', textAlign: 'center', fontWeight: 'bold', color: '#0000009e' }}>Рассчёт цен</div>
                    <div style={{ border: '2px solid #0000006c', padding: '10px', borderRadius: '5px', marginTop: '20px' }}>
                      <Row style={{ justifyContent: 'space-between' }}>
                        <TextGrey>Коеффициент логистики, %</TextGrey>
                        <Input
                          center style={{ width: '60px' }}
                          disabled={!isOwner}
                          value={supply.wb_info?.tariff?.delivery?.coef}
                          onBlur={async (v) => {
                            const newSupply = await SuppliesApi.changeSupply({ data: { supplyId: supply.id, field: 'wb_info.tariff.delivery.coef', value: v } }).then(r => r.supply)
                            setSupply(newSupply)
                            await loadPage()

                          }}
                        />
                      </Row>
                      <Row style={{ marginTop: '5px', justifyContent: 'space-between' }}>
                        <TextGrey>Логистика первого литра</TextGrey>
                        <Input
                          center style={{ width: '60px' }}
                          disabled={!isOwner}
                          value={supply.wb_info?.tariff?.delivery?.liter}
                          onBlur={async (v) => {
                            const newSupply = await SuppliesApi.changeSupply({ data: { supplyId: supply.id, field: 'wb_info.tariff.delivery.liter', value: v } }).then(r => r.supply)
                            setSupply(newSupply)
                            await loadPage()
                          }}
                        />
                      </Row>
                      <Row style={{ marginTop: '5px', justifyContent: 'space-between' }}>
                        <TextGrey>Логистика последующего литра</TextGrey>
                        <Input
                          center style={{ width: '60px' }}
                          disabled={!isOwner}
                          value={supply.wb_info?.tariff?.delivery?.step}
                          onBlur={async (v) => {
                            const newSupply = await SuppliesApi.changeSupply({ data: { supplyId: supply.id, field: 'wb_info.tariff.delivery.step', value: v } }).then(r => r.supply)
                            setSupply(newSupply)
                            await loadPage()
                          }}
                        />
                      </Row>
                    </div>
                    <div style={{ border: '2px solid #0000006c', padding: '10px', borderRadius: '5px', marginTop: '10px' }}>
                      <Row style={{ marginTop: '5px', justifyContent: 'space-between' }}>
                        <TextGrey>Коеффициент хранения, %</TextGrey>
                        <Input
                          center style={{ width: '60px' }}
                          disabled={!isOwner}
                          value={supply.wb_info?.tariff?.storage?.coef}
                          onBlur={async (v) => {
                            const newSupply = await SuppliesApi.changeSupply({ data: { supplyId: supply.id, field: 'wb_info.tariff.storage.coef', value: v } }).then(r => r.supply)
                            setSupply(newSupply)
                            await loadPage()
                          }}
                        />
                      </Row>
                      <Row style={{ marginTop: '5px', justifyContent: 'space-between' }}>
                        <TextGrey>Хранение первого литра</TextGrey>
                        <Input
                          center style={{ width: '60px' }}
                          disabled={!isOwner}
                          value={supply.wb_info?.tariff?.storage?.liter}
                          onBlur={async (v) => {
                            const newSupply = await SuppliesApi.changeSupply({ data: { supplyId: supply.id, field: 'wb_info.tariff.storage.liter', value: v } }).then(r => r.supply)
                            setSupply(newSupply)
                            await loadPage()
                          }}
                        />
                      </Row>
                      <Row style={{ marginTop: '5px', justifyContent: 'space-between' }}>
                        <TextGrey>Хранение последующего литра</TextGrey>
                        <Input
                          center style={{ width: '60px' }}
                          disabled={!isOwner}
                          value={supply.wb_info?.tariff?.storage?.step}
                          onBlur={async (v) => {
                            const newSupply = await SuppliesApi.changeSupply({ data: { supplyId: supply.id, field: 'wb_info.tariff.storage.step', value: v } }).then(r => r.supply)
                            setSupply(newSupply)
                            await loadPage()
                          }}
                        />
                      </Row>
                    </div>
                    <Row style={{ marginTop: '15px', justifyContent: 'space-between' }}>
                      <TextGrey>Маржинальность, %</TextGrey>
                      <Input
                        center style={{ width: '60px' }}
                        disabled={!isOwner}
                        value={supply.wb_info?.marginality?.percent}
                        onBlur={async (v) => {
                          const newSupply = await SuppliesApi.changeSupply({ data: { supplyId: supply.id, field: 'wb_info.marginality.percent', value: v } }).then(r => r.supply)
                          setSupply(newSupply)
                          await loadPage()
                        }}
                      />
                    </Row>
                    <Row style={{ marginTop: '5px', justifyContent: 'space-between' }}>
                      <TextGrey>Маржинальность мин, руб.</TextGrey>
                      <Input
                        center style={{ width: '60px' }}
                        disabled={!isOwner}
                        value={supply.wb_info?.marginality?.min_rub}
                        onBlur={async (v) => {
                          const newSupply = await SuppliesApi.changeSupply({ data: { supplyId: supply.id, field: 'wb_info.marginality.min_rub', value: v } }).then(r => r.supply)
                          setSupply(newSupply)
                          await loadPage()
                        }}
                      />
                    </Row>
                    <Row style={{ marginTop: '5px', justifyContent: 'space-between' }}>
                      <TextGrey>Транзит, руб.</TextGrey>
                      <Input
                        center style={{ width: '60px' }}
                        disabled={!isOwner}
                        value={supply.transit_cost}
                        onBlur={async (v) => {
                          const newSupply = await SuppliesApi.changeSupply({ data: { supplyId: supply.id, field: 'transit_cost', value: v } }).then(r => r.supply)
                          setSupply(newSupply)
                          await loadPage()
                        }}
                      />
                    </Row>
                    <Row style={{ marginTop: '5px', justifyContent: 'space-between' }}>
                      <TextGrey>Стоимость короба, руб.</TextGrey>
                      <Input
                        center style={{ width: '60px' }}
                        disabled={!isOwner}
                        value={supply.box_cost}
                        onBlur={async (v) => {
                          const newSupply = await SuppliesApi.changeSupply({ data: { supplyId: supply.id, field: 'box_cost', value: v } }).then(r => r.supply)
                          setSupply(newSupply)
                          await loadPage()
                        }}
                      />
                    </Row>
                    <Row style={{ marginTop: '5px', justifyContent: 'space-between' }}>
                      <TextGrey>Доп. расход, руб.</TextGrey>
                      <Input
                        center style={{ width: '60px' }}
                        disabled={!isOwner}
                        value={supply.extra_cost}
                        onBlur={async (v) => {
                          const newSupply = await SuppliesApi.changeSupply({ data: { supplyId: supply.id, field: 'extra_cost', value: v } }).then(r => r.supply)
                          setSupply(newSupply)
                          await loadPage()
                        }}
                      />
                    </Row>
                  </div>
                  <Row style={{ marginTop: '20px', justifyContent: 'space-between' }}>
                    <SendButton
                      // multiple={true}
                      sendApi={SuppliesApi.savePurchase}
                      sendData={{ data: { supplyId: supply.id } }}
                    // style={{ marginTop: '15px' }}
                    // disabled={!(selectedWarehouse.name && shop)}
                    >
                      Подгрузить позиции
                    </SendButton>
                    <Button
                      type={TYPE_BUTTONS.WHITE}
                      onClick={async () => {
                        await SuppliesApi.excelTemplatePurchase({ data: {} })
                      }}
                    >
                      Шаблон
                    </Button>

                  </Row>
                  <Button
                    type={TYPE_BUTTONS.GREEN}
                    style={{
                      backgroundColor: supply.ip_prices_calculated === false ? '#ed6e14d3' : '',
                      marginTop: '10px'
                    }}
                    disabled={!isOwner}
                    onClick={async () => {
                      await SuppliesApi.updatePrices({ data: { supplyId: supply.id } })
                      await loadPage()

                    }}
                  >
                    Пересчитать цены
                  </Button>
                </div>
              </Row>
            </WhiteBlock>
          )}

          {/* <SummaryBlock providersIdInShipment={providersIdInShipment} provider={provider} allProviders={allProviders} styles={{ marginLeft: '20px', }} /> */}
        </Row >

        <div style={{ display: 'inline-flex', width: '100%' }}>

          <Column style={{ width: '1200px', flexGrow: '2', flexBasis: '0' }}>

            <WhiteBlock className={styles.search_block}>
              <Row className={styles.navigate_table}>
                <NavTabs
                  open_tab={tab}
                  tabs={NAVIGATE[mode]}
                  isNum={true}
                  num={countStock}
                  style_tab={styles.style_tab}
                  onChange={onChangeTab}
                />
                <Row>
                  <Select
                    style={{ width: 'auto' }}
                    select={mode}
                    list={
                      manySupplies ?
                        isOwner ?
                          MODES :
                          (isUser ?
                            MODES.slice(1, 2) :
                            MODES.slice(1, 1)
                          ) :
                        isOwner ?
                          MODES :
                          (isUser ?
                            MODES.slice(0, 2) :
                            MODES.slice(0, 1)
                          )
                    }
                    onSelect={(v) => {
                      setTab(0)
                      setPage(1)
                      setMode(v)
                    }}
                    // onSelect={(v) => dispatch(uiChangeShipmentMode(v))}
                    width="190px"
                  />
                </Row>
              </Row>

              {mode !== MODES[2] && (
                <>
                  <Row className={styles.row_input}>
                    <Input
                      value={search}
                      ref={inputRef}
                      onBlur={(v) => setSearch(v)}
                      onClickEnter={(v) => setSearch(v)}
                      label="Поиск"
                    />
                  </Row>
                  <Text style={{ marginTop: '10px' }}>{`Найдено: ${count}`}</Text>
                </>
              )}


              <Row spaceBetween={true}>

                <Row style={{ height: '70px', marginTop: '0px' }}>
                  <Select
                    label="Показать на странице"
                    select={show}
                    list={['20', '50', '100', '150', '200', '500', '1000']}
                    onSelect={(v) => setShow(v)}
                    width="150px"
                    style={{ marginRight: '15px' }}
                  />
                  {/* {mode !== MODES[2] && ( */}
                  <>
                    <Select
                      label="Поставщик"
                      select={provider}
                      valueFn={(p) => p.name}
                      list={providers}
                      width="200px"
                      onSelect={(v) => changeProvider(v)}
                      style={{ marginRight: '15px' }}
                    />
                    <Select
                      label="Сортировка"
                      select={sortType}
                      valueFn={(p) => p.name}
                      list={SORT_TYPE}
                      width="220px"
                      style={{ marginRight: '15px' }}
                      onSelect={(v) => setSortType(v)}
                    />
                    {mode === MODES[0] && (
                      <>
                        <Select
                          label="Короб"
                          select={boxFilter}
                          width="140px"
                          style={{ marginRight: '15px' }}
                          list={_.compact(['Не выбран', ...(supply?.boxes?.map(b => b.id) || []), 'Не указан'])}
                          onSelect={(v) => setBoxFilter(v)}
                        />
                        {/* <Row style={{ width: '170px', marginRight: '5px' }}>
                          <TextGrey style={{ marginRight: '10px' }}>Несписанные</TextGrey>
                          <Switch switched={notDebited} onClick={(v) => setNotDebited(v)} />
                        </Row> */}
                      </>
                    )}
                    {mode !== MODES[0] && (
                      <div style={{ margin: '3px 0 0 10px' }}>
                        <InputLabel>Дата заказа</InputLabel>
                        <Row style={{ position: 'relative', width: '150px' }}>
                          <DateInput
                            // label="Дата заказа"
                            className={styles.calendar}
                            value={orderDt}
                            onChange={(v) => {
                              console.log(v)
                              setOrderDt(v)
                            }}
                          />
                          <Button className={styles.close_button} onClick={() => setOrderDt(null)}>
                            <img src={close} style={{ marginLeft: '5px', width: '15px' }} />
                          </Button>
                        </Row>
                      </div>
                    )}
                  </>
                  {/* )} */}

                </Row>

                {mode === MODES[0] && (
                  <>
                    <Row style={{ width: '190px', marginRight: '5px' }}>
                      <TextGrey style={{ marginRight: '10px' }}>Поиск по складу</TextGrey>
                      <Switch switched={false} onClick={(v) => setSearchSkladMode(v)} />
                    </Row>
                  </>
                )}

                {mode === MODES[1] && (
                  <>
                    <Row style={{ width: '350px', marginRight: '5px' }}>
                      <TextGrey style={{ marginRight: '10px' }}>Показать цены</TextGrey>
                      <Switch switched={false} onClick={(v) => setPricesMode(v)} />
                      <Button
                        type={TYPE_BUTTONS.WHITE}
                        onClick={() => SuppliesApi.excelAnalitic({ data: params_stat })}
                        style={{ marginLeft: '25px' }}
                      >
                        Скачать аналитику
                      </Button>
                    </Row>
                  </>
                )}

              </Row>
            </WhiteBlock>

            <Table styles={styles.table}>

              {((isOwner || isUser) && (mode === MODES[1] || mode === MODES[2])) && (
                <>
                  <TableHeader whiteHeader>
                    <Row className={styles.block_calc}>
                      <TextGrey className={styles.text_grey}>Общий объем / упакованный / Кол-во упакованных заказов / Кол-во коробов </TextGrey>
                      <Text style={{ color: '#603b01c3' }} className={cn(styles.profit)}>{numberWithSpaces(Math.ceil(volume.common))} л. / {numberWithSpaces(Math.ceil(volume.packed))} л. / {numberWithSpaces(Math.ceil(volume.count_packed))} шт. / {numberWithSpaces(Math.ceil(volume.packed / 96))} шт.</Text>
                    </Row>
                  </TableHeader>
                </>
              )}
              {(isOwner && (mode === MODES[1] || mode === MODES[2])) && (
                <>
                  <TableHeader whiteHeader>
                    <Row className={styles.block_calc}>
                      <TextGrey className={styles.text_grey}>Итоговая прибыль по отчету: </TextGrey>
                      <Text fontSize={'19px'} style={{ color: profitStatistic?.total_profit_by_report > 0 ? '#01800eca' : '#6e0000d9' }} className={cn(styles.profit)}>{numberWithSpaces(Math.ceil(profitStatistic?.total_profit_by_report - storageStatistic?.total_storage))} руб. - {numberWithSpaces(Math.ceil(profitStatistic?.total_count_by_report))} заказов</Text>
                    </Row>
                    <Row className={styles.block_calc}>
                      <TextGrey className={styles.text_grey}>В пути (без отчета): </TextGrey>
                      <Text style={{ color: '#70942cc5' }} className={cn(styles.profit)}>{numberWithSpaces(Math.ceil(profitStatistic?.total_profit - profitStatistic?.total_profit_by_report))} руб. - {numberWithSpaces(Math.ceil(profitStatistic?.total_count - profitStatistic?.total_count_by_report))} заказов</Text>
                    </Row>
                    <Row className={styles.block_calc}>
                      <TextGrey className={styles.text_grey}>Реализованная закупка / всего:</TextGrey>
                      <Text style={{ color: '#603b01c3' }} className={cn(styles.profit)}>{numberWithSpaces(Math.ceil(profitStatistic?.total_purchase_by_report))} руб. / {numberWithSpaces(Math.ceil(profitStatistic?.total_purchase))} руб.</Text>
                    </Row>
                    {/* <Row className={styles.block_calc}>
                      <TextGrey className={styles.text_grey}>Всего закупка: </TextGrey>
                      <Text style={{ color: '#603b01c3' }} className={cn(styles.profit)}>{numberWithSpaces(Math.ceil(profitStatistic?.total_purchase))} руб.</Text>
                    </Row> */}
                    <Row className={styles.block_calc}>
                      <TextGrey className={styles.text_grey}>Процент выкупа: </TextGrey>
                      <Text fontSize={'20px'} style={{ color: colorByPercent(profitStatistic?.sold_count_by_report * 100 / profitStatistic?.total_count_by_report) }} className={cn(styles.profit)}>
                        {+(profitStatistic?.sold_count_by_report * 100 / profitStatistic?.total_count_by_report).toFixed(2) || '-'} %
                      </Text>
                    </Row>

                    <Row className={styles.block_calc}>
                      <TextGrey className={styles.text_grey}>Маржинальность: </TextGrey>
                      <Text fontSize={'20px'} style={{ color: '#838f01ad' }} className={cn(styles.profit)}>
                        {+(profitStatistic?.total_profit_by_report * 100 / profitStatistic?.total_purchase_by_report).toFixed(2) || '-'} %
                      </Text>
                    </Row>
                  </TableHeader>
                  <TableHeader whiteHeader>

                    <Row className={styles.block_calc}>
                      <TextGrey className={styles.text_grey}>Отмены по отчету: </TextGrey>
                      <Text style={{ color: '#6e0000bd' }} className={cn(styles.profit)}>{numberWithSpaces(Math.ceil(profitStatistic?.cancel_profit_by_report))} руб. ({numberWithSpaces(Math.ceil(profitStatistic?.cancel_profit))} руб.) - {numberWithSpaces(Math.ceil(profitStatistic?.cancel_count_by_report))} заказов</Text>
                    </Row>
                    <Row className={styles.block_calc}>
                      <TextGrey className={styles.text_grey}>Закупка бракованого товара: </TextGrey>
                      <Text style={{ color: '#6e0000bd' }} className={cn(styles.profit)}>-{numberWithSpaces(Math.ceil(profitStatistic?.cancel_return_pvz_purchase_by_report))} руб.</Text>
                    </Row>
                    <Row className={styles.block_calc}>
                      <TextGrey className={styles.text_grey}>Доступный заработок: </TextGrey>
                      <Text style={{ color: '#6a6e00bd' }} className={cn(styles.profit)}>{numberWithSpaces(Math.ceil(potentialProfit))} руб.</Text>
                    </Row>

                  </TableHeader>
                  <TableHeader whiteHeader>
                    <Row className={styles.block_calc}>
                      <TextGrey className={styles.text_grey}>Хранение всего: </TextGrey>
                      <Text style={{ color: '#603b01c3' }} className={cn(styles.profit)}>-{numberWithSpaces(Math.ceil(storageStatistic?.total_storage))} руб.</Text>
                    </Row>
                    <Row className={styles.block_calc}>
                      <TextGrey className={styles.text_grey}>Хранение сегодня: </TextGrey>
                      <Text style={{ color: '#603b01c3' }} className={cn(styles.profit)}>-{numberWithSpaces(Math.ceil(storageStatistic?.total_storage_today))} руб.</Text>
                    </Row>
                    <Row className={styles.block_calc}>
                      <TextGrey className={styles.text_grey}>Хранение в пвз: </TextGrey>
                      <Text style={{ color: '#950202c3' }} className={cn(styles.profit)}>-{numberWithSpaces(Math.ceil(profitStatistic?.cancel_pvz_storage_by_report))} руб.</Text>
                    </Row>
                    <Row className={styles.block_calc}>
                      <TextGrey className={styles.text_grey}>Возврат заблокированного товара: </TextGrey>
                      <Text style={{ color: '#950202c3' }} className={cn(styles.profit)}>-{numberWithSpaces(Math.ceil(profitStatistic?.total_return_blocked))} руб.</Text>
                    </Row>
                  </TableHeader>
                </>
              )}
              {mode === MODES[2] ?
                (<>
                  <TableHeader whiteHeader>
                    <HeaderTitle width={WIDTH_POSTING[5]} centerText>Дата</HeaderTitle>
                    <HeaderTitle width={WIDTH_POSTING[5]} centerText>Количество заказов</HeaderTitle>
                    <HeaderTitle width={WIDTH_POSTING[5]} centerText>Продано</HeaderTitle>
                    <HeaderTitle width={WIDTH_POSTING[5]} centerText>Отменено</HeaderTitle>
                    <HeaderTitle width={WIDTH_POSTING[5]} centerText>Прибыль</HeaderTitle>
                    <HeaderTitle width={WIDTH_POSTING[5]} centerText>В пути</HeaderTitle>

                  </TableHeader>
                </>)
                :
                (<>
                  <TableHeader whiteHeader>
                    {mode !== MODES[1] && (<>
                      <HeaderTitle width={WIDTH_POSTING[10]} centerText>Баркод</HeaderTitle>
                    </>
                    )}
                    <HeaderTitle width={WIDTH_POSTING[15]}>Площадка</HeaderTitle>
                    {mode !== MODES[1] && (
                      <>
                        <HeaderTitle width={WIDTH_POSTING[10]} centerText>Короб</HeaderTitle>
                        <HeaderTitle width={WIDTH_POSTING[8]} style={{ fontSize: 10 }} centerText={true}>Обработано</HeaderTitle>
                      </>
                    )}
                    <HeaderTitle width={WIDTH_POSTING[18]}>Наименование</HeaderTitle>
                    {mode === MODES[1] && (
                      <>
                        {pricesMode && (
                          <>
                            <HeaderTitle width={WIDTH_POSTING[6]} centerText={true}>Цена продажи</HeaderTitle>
                            <HeaderTitle width={WIDTH_POSTING[6]} centerText={true}>Цена закупки</HeaderTitle>
                            <HeaderTitle width={WIDTH_POSTING[13]} centerText={true}>Профит</HeaderTitle>
                            <HeaderTitle width={WIDTH_POSTING[16]} style={{ fontSize: 10 }} centerText>Маржин.</HeaderTitle>
                            <HeaderTitle width={WIDTH_POSTING[16]} centerText style={{ fontSize: 10 }}>Мин. прибыль</HeaderTitle>
                            <HeaderTitle width={WIDTH_POSTING[17]} centerText style={{ fontSize: 10 }}></HeaderTitle>
                          </>
                        )}
                        <HeaderTitle width={WIDTH_POSTING[7]} style={{ fontSize: 10 }} centerText={true}>Доставляется/Продано/Отменено/Возврат/Отправили</HeaderTitle>
                        {(tab === 7 || tab === 8) && (
                          <>
                            <HeaderTitle width={WIDTH_POSTING[6]} centerText={true}>Принято</HeaderTitle>
                            <HeaderTitle width={WIDTH_POSTING[6]} centerText={true}>Расхождение</HeaderTitle>
                            <HeaderTitle width={WIDTH_POSTING[6]} centerText={true}>На раскладке</HeaderTitle>
                          </>
                        )}
                      </>
                    )}
                    {mode === MODES[0] && (
                      <>
                        <HeaderTitle width={WIDTH_POSTING[16]} style={{ fontSize: 9 }} centerText={true}>Количество в коробе</HeaderTitle>
                      </>
                    )}
                    <HeaderTitle width={WIDTH_POSTING[0]} centerText={true}>Поставщик</HeaderTitle>
                    {mode === MODES[0] && <HeaderTitle width={WIDTH_POSTING[16]} style={{ fontSize: 9 }} centerText={true}>Количество в карточке</HeaderTitle>}
                    {mode !== MODES[0] && <HeaderTitle width={WIDTH_POSTING[5]} centerText={true}>Артикул поставщика</HeaderTitle>}
                    {mode === MODES[1] && (
                      <>
                        {isOwner && (<HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>Прибыль</HeaderTitle>)}
                        <HeaderTitle width={WIDTH_POSTING[6]} centerText={true}>Хранение</HeaderTitle>
                        <HeaderTitle width={WIDTH_POSTING[6]} style={{ fontSize: 9 }} centerText={true}>Остаток на складе / Должно</HeaderTitle>
                        <HeaderTitle width={WIDTH_POSTING[8]} style={{ fontSize: 9 }} centerText={true}>За сколько дней всё заказали</HeaderTitle>
                        <HeaderTitle width={WIDTH_POSTING[16]} style={{ fontSize: 9 }} centerText={true}>Дней со старта продаж</HeaderTitle>
                        <HeaderTitle width={WIDTH_POSTING[16]} style={{ fontSize: 10 }} centerText={true}>Заказов в день</HeaderTitle>
                        <HeaderTitle width={WIDTH_POSTING[8]} style={{ fontSize: 9 }} centerText={true}>За сколько дней выкупят</HeaderTitle>
                      </>
                    )}

                    {mode !== MODES[1] && (
                      <>
                        <HeaderTitle width={WIDTH_POSTING[16]} centerText={true}>Длина</HeaderTitle>
                        <HeaderTitle width={WIDTH_POSTING[16]} centerText={true}>Ширина</HeaderTitle>
                        <HeaderTitle width={WIDTH_POSTING[16]} centerText={true}>Высота</HeaderTitle>
                        <HeaderTitle width={WIDTH_POSTING[16]} centerText={true}>Объем</HeaderTitle>
                        <HeaderTitle width={WIDTH_POSTING[5]} centerText={true}>Годен до</HeaderTitle>
                        <HeaderTitle width={WIDTH_POSTING[3]} centerText={true}>Сложность упаковки</HeaderTitle>
                        <HeaderTitle width={WIDTH_POSTING[16]} centerText={true}>Вес</HeaderTitle>
                        <HeaderTitle width={WIDTH_POSTING[7]} centerText={true}>Штрихкод товара</HeaderTitle>
                        <HeaderTitle width={WIDTH_POSTING[15]} centerText={true}></HeaderTitle>
                      </>
                    )}
                  </TableHeader>
                </>)

              }

              {supplyItems.ids.map((supplyItemId) => {
                return (
                  <SupplyItemLine
                    maxDateOrdersCount={Math.max(...Object.values(supplyItems.byIds).map(i => i?.total?.total.count))}
                    packageMethods={packageMethods}
                    key={supplyItemId}
                    isOwner={isOwner}
                    isAdmin={isAdmin}
                    tab={tab}
                    pricesMode={pricesMode}
                    boxes={supply.boxes}
                    MODES={MODES}
                    mode={mode}
                    manySupplies={manySupplies}
                    product={supplyItems.byIds[supplyItemId]}
                    changeProductsInSupply={changeProductsInSupply}
                    onChangeCard={onChangeCard}
                    printSticker={printSticker}
                    getByDateStat={getByDateStat}
                  />
                );
              })}
            </Table>

            <TablePagination num={Math.ceil(count / show) || 1} show={page} onChange={onChangePage} />
            {openChzn.open && (
              <ChznWindowPopUp
                product={openChzn.product}
                posting={openChzn.posting}
                close={() => setOpenChzn({ open: false, posting: null, product: null })}
              />
            )}
          </Column>

          {mode === MODES[0] && searchSkladMode && (
            <SearchCardsBlock
              // activeBox={activeBox}
              // shop={MARKETS_MAP[shop]}
              shop={supply.shop}
              providerId={provider.id}
              skladName={supply.sklad}
              printSticker={printSticker}
            />
          )}

        </div>

      </Content >
    </>
  );
}

export default SupplyPage;